<template>
  <div>
    <div class="modal fade" id="loginModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Вход администратора</h5>
            <button type="button" class="close" ref="loginModalClose" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <label for="password">Введите пароль</label>
            <input class="form-control" id="password" name="password" v-model="password">
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-primary" @click="login">Войти</button>
          </div>
          <div v-if="error.length > 0" class="alert alert-danger" role="alert">{{ error }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: "Login",
  data() {
    return {
      password: '',
      error: '',
    }
  },
  methods: {
    login() {
      this.error = '';
      var data = {
        password: this.password,
      }
      axios.post('auth/login', data).then((resp) => {
        this.$refs.loginModalClose.click();
        this.$store.dispatch('login', resp);
      }).catch((err) => this.error = err.response.data);
    },
  },
}
</script>

<style>
</style>
